import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import {
    Config,
    Colours,
    IconGift,
} from '@ratehub/base-ui';

import PATHS from '../../src/definitions/Paths';


function SidebarReferralsCTA({ className, ...otherProps }) {
    return (
        <SidebarAnchor
            // There is only an EN version of the Referrals landing page
            // currently. Plan is to enable this sidebar component on EN
            // pages only.
            href={Config.RATEHUB_BASE_URL + PATHS.REFERRALS_LANDING_PAGE_EN}
            data-name="sidebarReferralsCTA"
            className={classNames('rh-display-flex rh-justify-content-center rh-align-items-center rh-box-sizing-border-box rh-bg-grape-lightest rh-border-width-1px rh-border-style-solid rh-border-color-grape-lightest rh-text-s rh-text-decoration-none rh-border-radius-4px rh-py-1 rh-px-0_75 rh-mt-0 rh-mb-auto rh-width-100p', className)}
            {...otherProps}
        >
            <IconGift
                className="icon"
                fill={Colours.TRANSPARENT}
                stroke={Colours.GRAPE_DARKEST}
                outlineWidth="0"
                width="2em"
                height="2em"
            />

            <span className="label rh-fg-grape-dark rh-border-radius-4px weight-medium">
                <FormattedMessage
                    id="web-components.SidebarReferralsCTA.ctaLabel"
                    defaultMessage="Refer and earn"
                />
            </span>
        </SidebarAnchor>
    );
}

SidebarReferralsCTA.propTypes = {
    className: PropTypes.string,
};

const SidebarAnchor = styled.a`
    transition: color 200ms ease-out;

    &:hover,
    &:active,
    &:focus {
        cursor: pointer;

        > .label {
            color: ${Colours.GRAPE_DARKEST};
        }
    }
`;

export default SidebarReferralsCTA;
